(function () {
    'use strict';

    var SCROLL_THRESHOLD = 300;   // 何pxスクロールしたら表示するか
    var SCROLL_INTERVAL = 20;     // setInterval の間隔(ms)
    var SCROLL_FACTOR = 0.85;     // 減速係数

    var pagetopButton = document.getElementById('js--pagetop-button');
    if (!pagetopButton) return;

    var scrolling = false;        // スクロール中フラグ
    var scrollTimerId = null;     // setInterval のID保持

    // add/removeEventListener で同じオプションを使えるように変数に保持
    var nonPassiveOption = { passive: false };

    /**
     * スクロール位置に応じてボタン表示・非表示を切り替え
     */
    function updateButtonVisibility() {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

        if (scrollY > SCROLL_THRESHOLD) {
            pagetopButton.classList.add('is-visible');
        } else {
            pagetopButton.classList.remove('is-visible');
        }
    }

    /**
     * スクロール中のホイール / タッチ移動を無効化するハンドラ
     */
    function scrollControl(event) {
        if (!scrolling) {
            return;
        }
        event.preventDefault();
    }

    /**
     * スクロール禁止（ページトップに戻っている間）
     */
    function disableScroll() {
        // wheel（標準）と touchmove を抑制
        document.addEventListener('wheel', scrollControl, nonPassiveOption);
        document.addEventListener('touchmove', scrollControl, nonPassiveOption);
    }

    /**
     * スクロール禁止を解除
     */
    function enableScroll() {
        document.removeEventListener('wheel', scrollControl, nonPassiveOption);
        document.removeEventListener('touchmove', scrollControl, nonPassiveOption);
    }

    /**
     * ページトップへスムーズに戻る
     * （元コードの setInterval をほぼ踏襲）
     */
    function scrollToTop() {
        if (scrolling) {
            // 連打されたとき用のガード
            return;
        }

        scrolling = true;
        disableScroll();

        scrollTimerId = window.setInterval(function () {
            var lastPosition = window.pageYOffset || document.documentElement.scrollTop || 0;

            // 減速しながらスクロール
            var nextPosition = lastPosition * SCROLL_FACTOR - 5;
            if (nextPosition < 0) {
                nextPosition = 0;
            }

            window.scrollTo(0, nextPosition);

            if (lastPosition <= 0) {
                // 一番上に到達したら停止
                window.clearInterval(scrollTimerId);
                scrollTimerId = null;
                scrolling = false;
                enableScroll();
            }
        }, SCROLL_INTERVAL);
    }

    /**
     * イベント登録
     * defer または DOMContentLoaded 後に実行される前提
     */
    window.addEventListener('scroll', updateButtonVisibility, { passive: true });

    pagetopButton.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToTop();
    });

    // 初期表示判定
    updateButtonVisibility();
})();
